import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import ProjectedFundingGapsByGniGroupTable from "./ProjectedFundingGapsByGniGroupTable";
import SectorChooser from "../../choosers/SectorChooser";

const ProjectedFundingGapsByGniGroupTableWidget = props => {
  const [sectorId, setSectorId] = useState();

  return (
    <DataViewerFrame
      reference="Table 1.4"
      title="Projected Cost Share and Gaps, 2020 and 2025"
      subtitle="Segmented by GNI Group"
      filters={[
        <SectorChooser
          id="table-1-4"
          sectorIds={new Set([1, 2, 3])}
          selectedKey={sectorId}
          onChange={sectorId => {
            setSectorId(sectorId);

            props.onChange({
              widget: "theme1.projectedFundingGapsByGniGroupTable",
              payload: {
                sectorId
              }
            });
          }}
        />
      ]}
      onDownloadCsv={() => {
        props.onDownloadCsv({
          sector: sectorId ? props.database.sectors[sectorId] : "All"
        });
      }}
    >
      <ProjectedFundingGapsByGniGroupTable
        database={props.database}
        data={props.data}
        sectorIds={sectorId && new Set([sectorId])}
      />
    </DataViewerFrame>
  );
};

ProjectedFundingGapsByGniGroupTableWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default ProjectedFundingGapsByGniGroupTableWidget;
